import axios from "axios";
import { baseURL } from "./urlAPI";
import { getToken } from "app/reducers/auth";

const instance = axios.create({
  baseURL: baseURL,
});

instance.interceptors.request.use((config) => {
  try {
    let token = getToken();
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: "Bearer " + token,
      };
    }
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});

export const getProductCategory = async (url) => {
  const res = await instance.get(url);
  return res?.data;
};

export const getTransactionWallet = async (url) => {
  const res = await instance.get(url);
  return res?.data;
};

export const deleteProductCategory = async (url) => {
  const res = await instance.delete(url);
  return res?.data;
};

export const postImage = async (url, params) => {
  const res = await instance
    .post(url, params, {
      headers: {
        "Content-Type": "multipart/form-data",
        accept: "*/*",
      },
    });
  return res?.data;
};

export const deleteImage = async (url) => {
  const res = await instance.delete(url);
  return console.log(res);
};

export const addNewCate = async (url, params, config) => {
  const res = await instance.post(url, params, config);
  return res?.data;
};

export const updateCate = async (url, params, config) => {
  const res = await instance.patch(url, params, config);
  return res?.data;
};
export const updateSortCategory = async (url, params) => {
  const res = await instance.post(url, params);
  return res?.data;
};
export const putApi = async (url, params) => {
  try {
    const res = await instance.put(url, params);
    return res?.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw new Error(`API error: ${error.message}`);
  }
};

export default instance;
